$(document).ready(function () {

    if ($('.salePromocode').length) {
        var btn = $('.salePromocode .salePromocode__btn');
        var code = btn.data('code');
        var productId = btn.data('product');

        $.ajax({
            url: "/ajax/checkPromocodeInDetail.php",
            method: "POST",
            data: {'CODE': code, 'PRODUCT': productId},
            cache: false
            })
            .success(function (html) {
                btn.addClass(html);
            });

        $('.salePromocode .salePromocode__btn').on('click', function () {
            var btn = $(this);
            var code = $(this).data('code');
            var productId = $(this).data('product');

           // if($('.offer-list-item').length > 0) {
                if ($('.offer-list-item').length > 0 && $('.offer-list-item.selected').length == 0) {
                    $('.errorBox').show();
                } else {
                    if($('.offer-list-item').length > 0 && $('.offer-list-item.selected').length > 0) {
                        productId = $('.offer-list-item.selected').data('offer');
                    }
                    $.ajax({
                        url: "/ajax/applyPromoCode.php",
                        method: "POST",
                        data: {CODE: code, 'PRODUCT': productId},
                        cache: false
                    })
                        .success(function (html) {
                            btn.addClass('applied');
                            //$('.btn-buy-wrap .btn.btn-link').trigger('click');
                             window.location.href = '/cart/';
                        })
                }
           // }

            return false;
        })

    }

});
